import React, { useState, useEffect } from 'react';
import './insights.css';
import InsightsCard from './insightsCard';
import config from '../config';
import Table from './table';

function Insights() {
  const [selectedCards, setSelectedCards] = useState([]);
  const [activeTab, setActiveTab] = useState('Vertical');
  const [cardData, setCardData] = useState(null);

  const [showDateFilter, setShowDateFilter] = useState(true);
  const dateOptions = ["Today", "Last Week", "Last Month", "Last Year", "Custom"];
  const verticalOptions = ["Artwork", "Content", "Video", "Web Application"];
  const statusOptions = ["Completed", "Ongoing", "Upcoming"];
  const [selectedDate, setSelectedDate] = useState(null);
  const [showVerticalFilter, setShowVerticalFilter] = useState(true);
  const [showStatusFilter, setShowStatusFilter] = useState(true);
  const [selectedVerticals, setSelectedVerticals] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const years = Array.from({ length: 10 }, (_, i) => 2026 - i);
  const [fromDay, setFromDay] = useState();
  const [fromMonth, setFromMonth] = useState();
  const [fromYear, setFromYear] = useState();

  const [toDay, setToDay] = useState();
  const [toMonth, setToMonth] = useState();
  const [toYear, setToYear] = useState();


  const fetchData = async (val) => {
    let URL = 'https://alembicdigilabs.in/digilabs/mis/dtable';
    try {
      const response = await fetch(URL + `?viewall=${val}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      const result = data.result;
      let Data = {
        ...result,
        overall_total: { ...result["Grand Total"], title: 'Overall Work Count', color: 'white', footerColor: 'rgba(255, 255, 255, 0.12)' },
        artwork: { ...result.Artwork, title: 'Artwork', color: ' rgba(43, 99, 77, 1)', footerColor: 'rgba(217, 237, 229, 0.4)', icon: config.artwork, hoverColor: 'rgba(43, 99, 77, 0.21)', },
        video: { ...result.Video, title: 'Video', color: 'rgba(172, 56, 56, 1)', footerColor: 'rgba(255, 233, 233, 0.4)', icon: config.video, hoverColor: 'rgba(172, 56, 56, 0.21)' },
        content_writing: { ...result["Content"], title: 'Content', color: 'rgba(92, 92, 92, 1)', footerColor: 'rgba(229, 229, 229, 0.4)', icon: config.content, hoverColor: 'rgba(92, 92, 92, 0.21)' },
        web_application: { ...result["Web Application"], title: 'Web Application', color: 'rgba(73, 26, 203, 1)', footerColor: 'rgba(239, 234, 250, 0.4)', icon: config.web, hoverColor: 'rgba(73, 26, 203, 0.21)' },
        art_direction: { ...result["Art Direction"], title: 'Art Direction', color: 'rgba(189, 96, 3, 1)', footerColor: 'rgba(255, 245, 224, 0.4)', icon: config.artDirection, hoverColor: 'rgba(73, 26, 203, 0.21)' },
        shoot: { ...result.shoot, title: 'Shoot', color: 'rgba(4, 129, 174, 1)', footerColor: 'rgba(229, 241, 255, 0.4)', icon: config.shoot, hoverColor: 'rgba(4, 129, 174, 0.21)' },
        clm: { ...result.clm, title: 'CLM', color: 'rgba(151, 2, 104, 1)', footerColor: 'rgba(255, 233, 248, 0.4)', icon: config.clm, hoverColor: 'rgba(151, 2, 104, 0.21)' },
      };
      setCardData(Data);
    } catch (err) {
      // setError(err.message);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    // fetchData(true);
  }, [selectedCards, activeTab]);

  const toggleVertical = (option) => {
    setSelectedVerticals(prev =>
      prev.includes(option) ? prev.filter(v => v !== option) : [...prev, option]
    );
  };

  const toggleStatus = (option) => {
    setSelectedStatuses(prev =>
      prev.includes(option) ? prev.filter(s => s !== option) : [...prev, option]
    );
  };


  return (
    <div className='insights transition-container'>
      <div style={{ overflowY: 'scroll', maxHeight: '750px' }}>
        <header>
          <p>Digilabs MIS</p>
        </header>
        <div style={{ marginTop: '1rem', maxWidth: '99%' }}>
          <Table onTabChange={(tab) => { setActiveTab(tab) }} selectedCards={selectedCards} filters={{
            selectedDate,
            fromDay, fromMonth, fromYear,
            toDay, toMonth, toYear,
            selectedVerticals,
            selectedStatuses
          }} />
        </div>
      </div>
      <div className='filter_section'>
        {/* <InsightsCard data={cardData?.overall_total} /> */}
        <div className='filter_selection_wrapper'>

          <div style={{ borderBottom: '1px solid rgba(199, 199, 199, 1)' }}>
            <div className='filter_selection_item' onClick={() => setShowDateFilter(!showDateFilter)}>
              <img src={config.calenderBlack} alt='' />
              <p>Date</p>
              <img src={!showDateFilter ? config.downArrow : config.upArrow} alt='' />
            </div>
            {showDateFilter && (
              <div className="date_filter_dropdown">
                {dateOptions
                  .filter(option => selectedDate === 'Custom' ? option === 'Custom' : true)
                  .map((option) => (
                    <label key={option} className="date_option">
                      <input
                        type="checkbox"
                        name="dateFilter"
                        checked={selectedDate === option}
                        onChange={() => setSelectedDate(selectedDate === option ? null : option)}
                      />
                      <span>{option}</span>
                    </label>
                  ))}

                {selectedDate === "Custom" && (
                  <div className="custom_date_range">
                    <div className="date_group">
                      <label className="group_label">From:</label>
                      <div style={{ display: 'flex', gap: '10px' }}>

                        {/* Day */}
                        <div className={`select_wrapper ${fromDay ? 'active' : ''}`}>
                          <span className="placeholder">Day</span>
                          <select value={fromDay} onChange={(e) => setFromDay(e.target.value)} required>
                            <option value=""></option>
                            {Array.from({ length: 31 }, (_, i) => (
                              <option key={i + 1} value={i + 1}>{i + 1}</option>
                            ))}
                          </select>
                        </div>

                        {/* Month */}
                        <div className={`select_wrapper ${fromMonth ? 'active' : ''}`}>
                          <span className="placeholder">Month</span>
                          <select value={fromMonth} onChange={(e) => setFromMonth(e.target.value)} required>
                            <option value=""></option>
                            {months.map((m, i) => (
                              <option key={i} value={i + 1}>{m}</option>
                            ))}
                          </select>
                        </div>

                        {/* Year */}
                        <div className={`select_wrapper ${fromYear ? 'active' : ''}`}>
                          <span className="placeholder">Year</span>
                          <select value={fromYear} onChange={(e) => setFromYear(e.target.value)} required>
                            <option value=""></option>
                            {years.map((y) => (
                              <option key={y} value={y}>{y}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="date_group">
                      <label className="group_label">To:</label>
                      <div style={{ display: 'flex', gap: '10px' }}>

                        {/* Day */}
                        <div className={`select_wrapper ${toDay ? 'active' : ''}`}>
                          <span className="placeholder">Day</span>
                          <select value={toDay} onChange={(e) => setToDay(e.target.value)} required>
                            <option value=""></option>
                            {Array.from({ length: 31 }, (_, i) => (
                              <option key={i + 1} value={i + 1}>{i + 1}</option>
                            ))}
                          </select>
                        </div>

                        {/* Month */}
                        <div className={`select_wrapper ${toMonth ? 'active' : ''}`}>
                          <span className="placeholder">Month</span>
                          <select value={toMonth} onChange={(e) => setToMonth(e.target.value)} required>
                            <option value=""></option>
                            {months.map((m, i) => (
                              <option key={i} value={i + 1}>{m}</option>
                            ))}
                          </select>
                        </div>

                        {/* Year */}
                        <div className={`select_wrapper ${toYear ? 'active' : ''}`}>
                          <span className="placeholder">Year</span>
                          <select value={toYear} onChange={(e) => setToYear(e.target.value)} required>
                            <option value=""></option>
                            {years.map((y) => (
                              <option key={y} value={y}>{y}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="custom_date_buttons">
                      <button
                        type="button"
                        className="cancel_btn"
                        onClick={() => {
                          setSelectedDate(null);
                          setFromDay(""); setFromMonth(""); setFromYear("");
                          setToDay(""); setToMonth(""); setToYear("");
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="apply_btn"
                        onClick={() => {
                          // You can trigger your filter logic here
                          console.log("Apply clicked", { fromDay, fromMonth, fromYear, toDay, toMonth, toYear });
                        }}
                        disabled={!fromDay || !fromMonth || !fromYear || !toDay || !toMonth || !toYear}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}

              </div>
            )}

          </div>

          <div style={{ borderBottom: '1px solid rgba(199, 199, 199, 1)' }}>
            <div
              className='filter_selection_item'
              onClick={() => setShowVerticalFilter(!showVerticalFilter)}
            >
              <img src={config.verticals} alt='' />
              <p>Verticals</p>
              <img src={!showVerticalFilter ? config.downArrow : config.upArrow} alt='' />
            </div>
            {showVerticalFilter && (
              <div className="date_filter_dropdown">
                {verticalOptions.map((option) => (
                  <label key={option} className="date_option">
                    <input
                      type="checkbox"
                      checked={selectedVerticals.includes(option)}
                      onChange={() => toggleVertical(option)}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            )}
          </div>

          <div>
            <div
              className='filter_selection_item'
              onClick={() => setShowStatusFilter(!showStatusFilter)}
            >
              <img src={config.settings} alt='' />
              <p>Project Status</p>
              <img src={!showStatusFilter ? config.downArrow : config.upArrow} alt='' />
            </div>
            {showStatusFilter && (
              <div className="date_filter_dropdown">
                {statusOptions.map((option) => (
                  <label key={option} className="date_option">
                    <input
                      type="checkbox"
                      checked={selectedStatuses.includes(option)}
                      onChange={() => toggleStatus(option)}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Insights
